import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import moment from "jalali-moment";
import { Col, Form } from "react-bootstrap";
import { Fragment } from "react";

function FilterTime({ searchParams, set }) {
  const getTime = ({ e, jTm = true, name = "" }) => {
    if (jTm) {
      if (e)
        return moment(
          e.year + "/" + e.month.number + "/" + e?.day,
          "jYYYY/jM/jD"
        ).format("YYYY-MM-DD");
      else return undefined;
    }

    const time = searchParams.get(name);

    return time
      ? moment(time, "YYYY-MM-DD").format("jYYYY/jMM/jDD")
      : undefined;
  };

  return (
    <Fragment>
      <Col xs="12" sm="5" lg="3" xxl="2">
        <Form.Label>از تاریخ:</Form.Label>
        <DatePicker
          calendar={persian}
          locale={persian_fa}
          value={getTime({ jTm: false, name: "startDate" })}
          style={{ width: "100%", height: "2.2rem" }}
          onChange={e =>
            set({
              label: "startDate",
              value: getTime({ e }),
            })
          }
        />
      </Col>

      <Col xs="12" sm="5" lg="3" xxl="2">
        <Form.Label>تا تاریخ:</Form.Label>
        <DatePicker
          calendar={persian}
          locale={persian_fa}
          value={getTime({ jTm: false, name: "endDate" })}
          style={{ width: "100%", height: "2.2rem" }}
          onChange={e =>
            set({
              label: "endDate",
              value: getTime({ e }),
            })
          }
        />
      </Col>
    </Fragment>
  );
}

export default FilterTime;
